

import { lang } from "./Lang";

const LOCALE_MAP = { pl: 'pl-PL', de: 'de-DE', cz: 'cs-CZ' };
const CURRENCY_MAP = { pl: 'PLN', de: 'EUR', cz: 'CZK' };

function getLocale() { return LOCALE_MAP[lang.current] || 'pl-PL'; }
function getCurrency() { return CURRENCY_MAP[lang.current] || 'PLN'; }

export function formatCurrency(val, {hideBlank = false, decimal = 2, showSign = false} = {}){
    const formatter = new Intl.NumberFormat(getLocale(), { style: 'currency', currency: getCurrency(), minimumFractionDigits: decimal });

    let sign = '';
    if(showSign){
        if(val < 0){
            sign = '-';
        }else if (val > 0){
            sign = '+';
        }
        
    }
    
    if(val != 0 || !hideBlank){
        return sign + formatter.format(val);
        
    }
    return '';
}

